import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { UAParser } from 'ua-parser-js';

import server from 'server/serverController2';
import constants from 'utils/constants'

import VerticalBtnCenterModal from 'components/presenters/modal/VerticalBtnCenterModal';

export default function ReviewModal({visible=false, setReviewModalVisible}) {
    const appleStoreLink = 'https://apps.apple.com/kr/app/%EB%AA%A8%ED%8B%B0%EB%84%88%EC%8A%A4/id1556370860';
    const googleStoreLink = 'https://play.google.com/store/apps/details?id=com.motiners.bundle';

    let parserObj = new UAParser(); 
    const OSInfo = parserObj.getOS(); 
    const appStoreLink = (OSInfo['name'] === "Android") ? googleStoreLink:appleStoreLink;
    const GOOGLE_FORM_LINK = 'https://forms.gle/zhzFPfXBP8HLWX2x7';

    const [modalVisible, setModalVisible] = useState(visible);
    const [dataList, setDataList] = useState(null);
    const [completeBtnList, setCompleteBtnList] = useState([]);
    const [initModal, setInitModal] = useState(false);

    const handleOpenStore = async () => {
        const response = await server.putRequestData(`users/confirm`, {review_modal: true});
        if(response.success !== 1)
        {
            const errData = response.error.res_data;
            if(errData.detail_code === 'LOGIN_REQ')
            {
                //CenterModal
            }
            setInitModal(true);
            return;
        }
        setInitModal(true);
        window.location.href = appStoreLink;
    }

    const handleOpenSurveyForm = async () => {
        const response = await server.putRequestData(`users/confirm`, {review_modal: true});
        if(response.success !== 1)
        {
            const errData = response.error.res_data;
            if(errData.detail_code === 'LOGIN_REQ')
            {
                //CenterModal
            }
            setInitModal(true);
            return;
        }
        setInitModal(true);
        window.location.href = GOOGLE_FORM_LINK;
    }
    
    const handlePositiveClick = () => {
        setDataList({
            title: `감사해요😊\n앱스토어에 평가 한마디\n해 주시겠어요?`
        })
        setCompleteBtnList([
            {wrapperStyle: {background:'#FFCF19', color: '#121212'}, text: '네,좋아요!', onAction: () => handleOpenStore()},
            {wrapperStyle: {color: '#4E4E4E'}, text: '다음에 할게요.', onAction: () => handleOpenStore()}
        ])
    }

    const handleNegativeClick = () => {
        setDataList({
            title: '어떤 점이 아쉬웠나요?\n의견주시면 개선할게요!'
        });
        setCompleteBtnList([
            {wrapperStyle: {background:'#FFCF19', color: '#121212'}, text: '네,의견 드릴게요!', onAction: () => handleOpenSurveyForm()},
            {wrapperStyle: {color: '#4E4E4E'}, text: '다음에 할게요.', onAction: () => setInitModal(true)}
        ]);
    }

    useEffect(() => {
        if(visible)
        {
            setDataList({
                image: `${constants.imagePath}/common/icon/motiners_round_icon-228x228.png`,
                title: '이번 챌린지,\n어떠셨나요?'
            })
            setCompleteBtnList([
                { wrapperStyle: {background:'#FFCF19', color: '#121212'}, text: '좋았어요!', onAction: () => handlePositiveClick() },
                { wrapperStyle: {color: '#4E4E4E'}, text: '아쉬웠어요!', onAction: () => handleNegativeClick() }
            ])
        }
    }, [visible]);

    useEffect(() => {
        if(initModal)
        {
            setDataList(null);
            setCompleteBtnList([]);
            setReviewModalVisible(false);
            setReviewModalVisible(false);
            setInitModal(false);
        }
    },[initModal]);

    return (
        <VerticalBtnCenterModal
            visible={visible}
            dataList={dataList} 
            btnList={completeBtnList} 
            setInitModal={setInitModal}
        />
    )
}
